import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

const generateTransactionBalanceAuditExcel = async (
  res,
  filename = "Transaction_Balance_Audit.xlsx"
) => {
  try {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Transaction Balances");

    worksheet.mergeCells("A1:Z1");
    worksheet.getCell("A1").value = "Transaction Balance Audit Report";
    worksheet.getCell("A1").font = { size: 14, bold: true };
    worksheet.getCell("A1").alignment = { horizontal: "center" };

    const rowsOrder = [
      { key: "openingBalance", label: "Opening balance" },
      { key: "directDeposit", label: "Direct deposit" },
      { key: "depositsViaApp", label: "Deposits via app" },
      { key: "fieldCollections", label: "Field officers" },
      { key: "transfersFromInactive", label: "Transfers from inactive accounts" },
      { key: "depositInterest", label: "Deposit interest" },
      { key: "equityInterest", label: "Equity interest" },
      { key: "errorCorrections", label: "Error corrections", isGroup: true },
      { key: "errorOfficials1", label: "1. By officials", forceEmpty: true },
      { key: "errorSoftware1", label: "2. By the software company", forceEmpty: true },
      { key: "otherCredits", label: "Other credits" },
      { label: "Credit collection", isGroup: true },
      { key: "directPayments", label: "Direct payments" },
      { key: "paymentsThroughApp", label: "Payments through the app" },
      { key: "loanInstallments", label: "Loan installments" },
      { key: "loanInterest", label: "Loan interest" },
      { key: "standingOrders", label: "Standing Orders" },
      { key: "refunds", label: "Refunds" },
      { key: "transferredToInactive", label: "Transferred to inactive accounts" },
      { key: "abandonedAccountsTransferred", label: "Abandoned accounts transferred" },
      { key: "errorCorrectionsDebits", label: "Error corrections", isGroup: true },
      { key: "errorOfficials2", label: "1. By officials", forceEmpty: true },
      { key: "errorSoftware2", label: "2. By the software company", forceEmpty: true },
      { key: "otherDebits", label: "Other debits" },
      { label: "Debit card", isGroup: true },
      { key: "debitCard", label: "Debit card" },
      { key: "finalBalance", label: "Final balance" },
    ];

    // Group data branch-wise
    const branchGroups = {};
    res.forEach((item) => {
      if (!branchGroups[item.branchName]) {
        branchGroups[item.branchName] = [];
      }
      branchGroups[item.branchName].push(item);
    });

    // Header row
    const headerRow = ["Description"];
    let colIndex = 2;

    Object.entries(branchGroups).forEach(([branchName, items]) => {
      const months = items.map((i) => i.month);
      worksheet.mergeCells(2, colIndex, 2, colIndex + months.length);
      worksheet.getCell(2, colIndex).value = branchName;
      worksheet.getCell(2, colIndex).alignment = { horizontal: "center" };
      worksheet.getCell(2, colIndex).font = { bold: true };
      months.forEach((m) => headerRow.push(m));
      
      headerRow.push("As of the audit date");

      colIndex += months.length + 1;
    });

    worksheet.addRow(headerRow);
    worksheet.getRow(3).font = { bold: true };
    worksheet.getRow(3).alignment = { horizontal: "center" };

    rowsOrder.forEach((row) => {
      const rowData = [row.label];
      Object.entries(branchGroups).forEach(([_, items]) => {
        items.forEach((monthData) => {
          if (row.isGroup || row.forceEmpty) {
            rowData.push("");
          } else {
            const value = monthData[row.key];
            rowData.push(value !== null && value !== undefined ? value : "");
          }
        });
        rowData.push("");
      });
      const excelRow = worksheet.addRow(rowData);
      if (row.isGroup) {
        excelRow.font = { bold: true };
      }
    });

    worksheet.columns.forEach((col, i) => {
      col.width = i === 0 ? 40 : 18;
    });

    worksheet.eachRow((row, rowNumber) => {
      row.eachCell((cell, colNumber) => {
        cell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };
        if (rowNumber > 3 && colNumber > 1 && typeof cell.value === "number") {
          cell.numFmt = "#,##0.00";
        }
      });
    });

    worksheet.views = [
      { state: "frozen", xSplit: 1, ySplit: 3, topLeftCell: "B4", activeCell: "B4" },
    ];

    const buffer = await workbook.xlsx.writeBuffer();
    const excelBlob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(excelBlob, filename);
  } catch (error) {
    console.error("Error generating Transaction Balance Audit Excel:", error);
  }
};

export default generateTransactionBalanceAuditExcel;
